import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderModel } from "@insite/client-framework/Types/ApiModels";

type ReorderParameter = {
    orderNumber: string;
} & HasOnSuccess &
    HasOnError<string>;

export interface ReorderResult {
    order: OrderModel;
    cartLines?: CartLineCollectionModel;
}

type HandlerType = ApiHandlerDiscreteParameter<ReorderParameter, CartLineCollectionModel, ReorderResult | undefined>;

export const PopulateApiParameterCustom: HandlerType = props => {
    if (!props.apiResult?.order.orderLines?.some(o => !!o.productId)) {
        props.apiResult = undefined;
        props.dispatch({
            type: "Pages/OrderHistory/CompleteReorder",
            orderNumber: props.parameter.orderNumber,
        });
        props.dispatch({
            type: "Context/CompleteUpdatingCart",
        });
        props.parameter.onError?.(siteMessage("OrderHistory_NoProductsAvailableForReorder") as string);
        return false;
    }

    const isSalesBlockPresent = props.apiResult.order.orderLines.some(
        line => line.properties.salesBlocked?.toLowerCase() === "true",
    );

    if (isSalesBlockPresent) {
        props.apiParameter = {
            cartLines: props.apiResult.order.orderLines
                .filter(line => line.properties?.salesBlocked?.toLowerCase() !== "true")
                ?.map(
                    line =>
                        ({
                            productId: line.productId,
                            qtyOrdered: line.qtyOrdered <= 0 ? 1 : line.qtyOrdered,
                            unitOfMeasure: line.unitOfMeasure,
                        } as CartLineModel),
                ),
        } as CartLineCollectionModel;
    } else {
        props.apiParameter = {
            cartLines: props.apiResult.order.orderLines.map(
                line =>
                    ({
                        productId: line.productId,
                        qtyOrdered: line.qtyOrdered <= 0 ? 1 : line.qtyOrdered,
                        unitOfMeasure: line.unitOfMeasure,
                    } as CartLineModel),
            ),
        } as CartLineCollectionModel;
    }
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterCustom);
